export default {"src":"/_next/static/media/shopping-bag.563307b1.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};